import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';

import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import {SelectComponent} from './select.component';

@NgModule({
  declarations: [SelectComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgbDropdownModule],
  exports: [SelectComponent]
})
export class UiSelectModule { }
